import React, { useRef, useState, useEffect } from "react";
import "./youtubeEmbed.scss";
import { PlayIcon } from "../../assets/Icons";
import { useWindowSize } from "react-use";

const YoutubeEmbed = ({
  videoId,
  thumbnail,
  mobileThumbnail,
  iconcss,
  iframecss,
  isHovered,
  images,
}) => {
  const { width } = useWindowSize();
  // const [isHovered, setIsHovered] = useState(false);
  const [shouldPlay, setShouldPlay] = useState(false);
  const containerRef = useRef(null);
  const timerRef = useRef(null);
  const isMobile = width <= 992;

  const youtubeFrame = () => (
    <iframe
      className={`${iframecss}`}
      src={`https://www.youtube.com/embed/${videoId}?playlist=${videoId}&rel=0&autoplay=1&mute=1&loop=1&controls=0`}
      title="YouTube video"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowfullScreen
      style={{ pointerEvents: "none" }}
    />
  );

  useEffect(() => {
    if (isHovered === videoId) {
      timerRef.current = setTimeout(() => {
        setShouldPlay(true);
      }, 4000);
    } else {
      clearTimeout(timerRef.current);
      timerRef.current = null;
      setShouldPlay(false);
    }

    return () => {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    };
  }, [isHovered]);

  return (
    <div className="w-full h-full relative" ref={containerRef}>
      <div
        className={`h-full w-full cursor-pointer relative transition-opacity duration-300 ${
          shouldPlay ? "opacity-0" : "opacity-100"
        }`}
      >
        {/* <img
          src={isMobile && mobileThumbnail ? mobileThumbnail : thumbnail}
          alt="Youtube Thumbnail"
          className="h-full w-full object-cover object-top"
        /> */}

        <picture>
          <source
            media="(max-width: 1024px) and (max-height: 768px)"
            srcSet={images[1].src}
          />

          <source
            media="(max-width: 1024px) and (min-height: 1292px)"
            srcSet={images[2].src}
          />

          <source
            media="(max-width: 1366px) and (max-height: 800px)"
            srcSet={thumbnail}
          />

          <source
            media="(max-width: 1366px) and (max-height: 950px)"
            srcSet={images[1].src}
          />

          <source
            media="(max-width: 1536px) and (max-height: 864px)"
            srcSet={thumbnail}
          />

          <source
            media="(max-width: 1600px) and (max-height: 1200px)"
            srcSet={images[1].src}
          />

          <source
            media="(min-width: 2560px) and (min-height: 1600px)"
            srcSet={images[0].src}
          />

          <img
            src={thumbnail}
            className="h-full w-full object-cover object-top"
            alt="Responsive Image"
          />
        </picture>

        <img
          src={PlayIcon}
          alt="Play Icon"
          className={`absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 ${iconcss}`}
        />
      </div>

      {shouldPlay && youtubeFrame()}
    </div>
  );
};

export default YoutubeEmbed;
